import React from 'react';
import { Logo } from './Logo';
const links = [{
  label: 'Preguntas frecuentes',
  href: '#faq'
}, {
  label: 'Contacto',
  href: '#'
}, {
  label: 'Términos',
  href: '#'
}, {
  label: 'Privacidad',
  href: '#'
}];
export function Footer() {
  return <footer className="border-t border-petrol/10 bg-cream-deep py-12" data-id="element-37" data-mp="32pp39tivff18">
      <div className="mx-auto flex max-w-6xl flex-col gap-8 px-5 sm:px-8 md:flex-row md:items-end md:justify-between" data-id="element-38" data-mp="36q92d2n08sq0">
        <div data-id="element-39" data-mp="3uftm3nqzfu0c">
          <Logo size="md" data-id="element-40" data-mp="3ucxsgbm63rhp" />
          <p className="mt-4 max-w-sm font-sans text-sm leading-relaxed text-petrol/70" data-id="element-41" data-mp="38h7nghhhuo4">
            Una app para empezar y organizar tu negocio de servicios para mascotas.
          </p>
        </div>

        <nav aria-label="Enlaces legales y de ayuda" data-id="element-42" data-mp="3qcxbokblj47h">
          <ul className="flex flex-wrap gap-x-6 gap-y-2" data-id="element-43" data-mp="3qbly5sscmi36">
            {links.map(link => <li key={link.label} data-id="element-44" data-mp="29xvp07mdh3mo">
                <a href={link.href} className="font-sans text-sm text-petrol-muted transition-colors duration-150 ease-soft hover:text-petrol" data-id="element-45" data-mp="2ey0907mhoghn">
                  {link.label}
                </a>
              </li>)}
          </ul>
          <p className="mt-6 font-sans text-xs text-petrol/50 md:text-right" data-id="element-46" data-mp="3v7q6vs7ueph3">
            © {new Date().getFullYear()} Pawsy Emprende
          </p>
        </nav>
      </div>
    </footer>;
}